import { ApocalypseFreespinBetPresentation } from "../freespin/ApocalypseFreespinBetPresentation";

export class ApocalypseFreespinBetterBetPresentation extends ApocalypseFreespinBetPresentation {
    constructor(protected id: string = `ApocalypseFreespinBetterBetPresentation`) {
        super(id);
    }
}
